import { NonEmptyArray } from 'fp-ts/NonEmptyArray';
import { Language } from '@mews-commander/data-access';
import { createSafeContext } from '@mews/framework';

export const { FormLanguageContextProvider, useFormLanguageContext } = createSafeContext<
    'FormLanguageContext',
    NonEmptyArray<Language>
>('FormLanguageContext');
